<div class="my-6">
  <div class="flex justify-between text-base items-center gap-4">
    <div class="flex gap-4 items-center">
      <p>{{ item().quantity }}
        x {{ 'product/' + product().id + '/name' | translate }}</p>
      @if (asGift()) {
        <div class="relative h-8 w-8">
          <img alt="" fill="" class="object-fill" ngSrc="assets/icons/yellow/gift.svg">
        </div>
      }
    </div>
    @if (siteService.price(product().id); as price) {
      <p
        class="font-semibold text-end w-28">{{ (item().quantity * price.price) | currency }}</p>
    }
  </div>
  @if (asGift()?.format === GiftFormat.mail) {
    <div class="flex justify-between text-base mt-2">
      <p>{{ item().quantity }} x {{ 'managementFees' | translate }}</p>
      <p
        class="font-semibold text-end w-20">{{ (item().quantity * siteService.price(productService.managementFee().id).price) | currency }}</p>
    </div>
  }
</div>
